import { FC } from "react";
import { useTranslation } from "react-i18next";
import { StyledTabItem, StyledTabs } from "./styled";

type Props = {
  data: {
    label: string;
    key: string;
  }[];
  active: string;
  onChange(value: string): void;
};

const Tabs: FC<Props> = ({ data, active, onChange }) => {
  const {t} = useTranslation();

  return (
    <StyledTabs>
      {data.map((item) => (
        <StyledTabItem key={`${item.key}`} $active={active === item.key} onClick={() => onChange(item.key)}>
          {t(item.label)}
        </StyledTabItem>
      ))}
    </StyledTabs>
  );
};

export default Tabs;
